import { render, staticRenderFns } from "./PatientRegster.vue?vue&type=template&id=83acc222&"
import script from "./PatientRegster.vue?vue&type=script&lang=js&"
export * from "./PatientRegster.vue?vue&type=script&lang=js&"
import style0 from "./PatientRegster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VApp,VProgressCircular})
